import axiosVerbose from './axios/axiosVerbose'
import { logError } from './errors'

const legacyAffiliates = (location: Location) => {
  axiosVerbose
    .get(
      `/shopfront_api/affiliate/legacy?location=${(window as any).escape(
        // TODO: escape is not recommended to be used, should look into changing to encodeURIComponent
        location.href
      )}`
    )
    .then(res => {
      if (res.data && res.data.redirect) {
        window.location.href = res.data.redirect_url
      }
    })
    .catch(logError)
}

export default legacyAffiliates



// WEBPACK FOOTER //
// ./common/utils/legacyAffiliates.ts